import { connect } from 'react-redux'
import CaAccordionSkeleton from 'pages/currentawareness/CaAccordionSkeleton'

const mapStateToProps = state => ({
  windowHeight: state.layout.windowHeight,
  headerHeight: state.layout.headerHeight
})

export default connect(mapStateToProps, null)(CaAccordionSkeleton)
